import React from "react";
import { useTranslation } from "react-i18next";
import { MessageOutlined } from "@ant-design/icons";

function Pricing() {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col justify-between w-full px-4 bg-[#F4F7FF] items-center py-8 md:py-16 scroll-mt-24 "
      style={{ borderBottom: "2px gray-500" }}
      id="pricing"
    >
      <div className="mx-auto mb-6 sm:mb-6 max-w-3xl text-center">
        <h2 className="mb-4 text-2xl sm:text-4xl font-extrabold tracking-normal leading-tight text-gray-900">
          {t("Plans & Pricing")}
        </h2>

        <p className="mb-7 text-base sm:text-lg text-gray-600">
          {t("Contact us on WhatsApp to know about the price")}
        </p>

        <a
          href="https://wa.me/201004505666?text=I%20want%20to%20know%20about%20Hisabak%20pricing"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center rounded-xl bg-primaryBlue px-7 py-4 text-[16px] font-semibold text-white transition hover:bg-blue-800 hover:-translate-y-1 hover:shadow-lg"
        >
          <MessageOutlined style={{ marginInline: "5px" }} />{" "}
          {t("Ask on WhatsApp")}
        </a>
      </div>
    </div>
  );
}

export default Pricing;
